module.exports = __webpack_public_path__ + "assets/img/29_233_big.d967baaf.jpg";